/**
 * Mando UI initialisation
 */

/* eslint-disable */
import Vue from "NodeModules/vue/dist/vue.min.js";

// Simple observable event bus to allow communication between components
Vue.prototype.$eventBus = new Vue();
import moment from "NodeModules/moment/moment";
import polyfillClosest from "../polyfill";
import header from "Components/reportAProblem/header/header";
import navigationOffCanvas from "Components/reportAProblem/navigation/navigation-off-canvas";
import navigationDropdown from "Components/reportAProblem/navigation-dropdown/navigation-dropdown";
import select from "Components/reportAProblem/forms/select/select";
import search from "Components/reportAProblem/search/search";
import accordion from "Components/reportAProblem/accordion/mando-ui.accordion";
import table from 'Components/reportAProblem/_rte-table/mando-ui.rte-table';

import notify from "Components/reportAProblem/notify/notify";

import postcode from "Components/reportAProblem/postcode-lookup/postcode";
import searchResults from "Components/reportAProblem/results/SearchResults.vue";
import documentLibrary from "Components/reportAProblem/document-library/DocumentLibrary.vue";
import cardList from "Components/reportAProblem/card-list/CardList.vue";
import meteredBill from 'Components/reportAProblem/bill-estimate/MeteredBill.vue';
import reportProblem from 'Components/reportAProblem/report-a-problem/_vue/ReportProblem.vue';
import contactUs from 'Components/reportAProblem/contact-us/_vue/ContactUs.vue';
import navigationModal from 'Components/reportAProblem/_navigation-modal/navigation-modal';
import skipTo from 'Components/reportAProblem/_accessmenu/accessmenu';

document.addEventListener("DOMContentLoaded", () => {
  // Add JS helper class
  document.getElementsByTagName("html")[0].classList.remove("no-js");
  document.getElementsByTagName("html")[0].classList.add("has-js");

  //* Polyfill
  polyfillClosest();
  // Components
  header();
  navigationOffCanvas();
  navigationDropdown();
  navigationModal();
	select();
  search();
  accordion();
  notify();
  postcode();
  table();
  skipTo();

  const searchResultsEl = document.querySelector("#search-results");
  const documentLibraryEl = document.querySelector("#document-library");
  const cardListEl = document.querySelector("#card-list");
  const meteredBillEl = document.querySelector('#bill-estimate');
  const reportProblemEl = document.querySelector('#report-a-problem');
  const contactUsEl = document.querySelector('#contact-us');

  Vue.filter("formatDate", (value) => {
    if (!value) {
      return "";
    }
    return moment(value).format("DD/MM/YY");
  });

  Vue.filter("formatFileSize", (value) => {
    return `${(value / Math.pow(1024, 1)).toFixed(2)}kB`;
  });

  Vue.filter("booleanToYesNo", (value) => (value ? "Yes" : "No"));

  if (searchResultsEl) {
    /* eslint-disable no-new */
    new Vue({
      el: "#search-results",
      render: (h) =>
        h(searchResults, {
          props: {
            searchLabel: searchResultsEl.dataset.searchLabel,
            searchDescription: searchResultsEl.dataset.searchDescription,
            sites: JSON.parse(searchResultsEl.dataset.sites),
          },
        }),
    });
    /* eslint-enable */
  }

  if (meteredBillEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#bill-estimate',
      render: h => h(meteredBill, {
        props: {
          billEstimateTitle: meteredBillEl.dataset.billEstimateTitle,
          billEstimateStep1: meteredBillEl.dataset.billEstimateStep1,
          billEstimateStep2: meteredBillEl.dataset.billEstimateStep2,
          billEstimateImage1: meteredBillEl.dataset.billEstimateImage1,
          billEstimateImage2: meteredBillEl.dataset.billEstimateImage2,
          waterCharge: meteredBillEl.dataset.waterCharge,
          standingWaterCharge: meteredBillEl.dataset.standingWaterCharge,
          standingSewageCharge: meteredBillEl.dataset.standingSewageCharge,
          sewerageCharge: meteredBillEl.dataset.sewerageCharge,
        },
      }),
    });
    /* eslint-enable */
  }

  if (documentLibraryEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#document-library',
      render: h =>
        h(documentLibrary, {
          props: {
            levelTags: JSON.parse(documentLibraryEl.dataset.levelTags),
            topicTags: JSON.parse(documentLibraryEl.dataset.topicTags),
            heading: documentLibraryEl.dataset.heading,
            componentId: documentLibraryEl.dataset.componentId,
            siteId: documentLibraryEl.dataset.siteId,
            primaryTagsLabel: documentLibraryEl.dataset.primaryTagsLabel,
            secondaryTagsLabel: documentLibraryEl.dataset.secondaryTagsLabel,
            headingTag: documentLibraryEl.dataset.headingTag,
          },
        }),
    });
    /* eslint-enable */
  }

  if (cardListEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#card-list',
      render: h =>
        h(cardList, {
          props: {
            categoryTags: JSON.parse(cardListEl.dataset.categoryTags),
            topicTags: JSON.parse(cardListEl.dataset.topicTags),
            componentId: cardListEl.dataset.componentId,
            siteId: cardListEl.dataset.siteId,
            textSearch: cardListEl.dataset.textSearch,
            categoryTagsTitle: cardListEl.dataset.categoryTagsTitle,
            topicTagsTitle: cardListEl.dataset.topicTagsTitle,
          },
        }),
    });
    /* eslint-enable */
  }

  if (reportProblemEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#report-a-problem',
      render: h => h(reportProblem),
    });
    /* eslint-enable */
  }
  if (contactUsEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#contact-us',
      render: h => h(contactUs, {
        props: {
          user: contactUsEl.dataset.user ? JSON.parse(contactUsEl.dataset.user) : null,
          content: JSON.parse(contactUsEl.dataset.content),
          panels: JSON.parse(contactUsEl.dataset.panels),
          rapComponentId: contactUsEl.dataset.rapComponentId,
          rapContent: JSON.parse(contactUsEl.dataset.rapContent),
          rapQuestions: JSON.parse(contactUsEl.dataset.rapQuestions),
        },
      }),
    });
    /* eslint-enable */
  }
});



// WEBPACK FOOTER //
// ./src/scripts/brands/reportAProblem.js